export default {
	"detailSplitDialog": {
		"relationCheckboxLable": "货品量与包装数是否关联修改",
		"initialization": "大于0且不能超过初始化数值",
		"confirmedSplit": "确认拆分"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/detailSplitDialog/detailSplitDialog.js